<template>
  <div class="k-header" ref="header">
    <div class="k-header-con">
      <div class="k-header-logo" @click="goHome()">
        <a href="#">
          <img src="../../assets/images/yx_logo_w.png" alt />
        </a>
		<span>{{info.views.version}}</span>
      </div>
      <ul class="k-header-nav" ref="ulli">
        <template v-for="(item,index) in info.views.menus">
            <li
              :key="index"
              v-if="item.is_show == 'YES' && item.menu_name == '审批'"
              :class="index == info.indexClic ? 'hov' : ''"
              @click="clickMenu(index)"
            >
              <a>
                {{ item.menu_name }}</a>
			  <!-- <a><el-badge :value="info.views.check_num" :max="99">
			    {{ item.menu_name }}
			  </el-badge></a> -->
            </li>
            <li
              :key="index"
              v-else-if="item.is_show == 'YES'"
              :class="index == info.indexClic ? 'hov' : ''"
              @click="clickMenu(index)"
            >
              <a>{{ item.menu_name }}</a>
            </li>
        </template>
		<!-- <li
		  @click="clickMenu(index)"
		>
		  <a>系统管理</a>
		</li> -->
      </ul>
	  <div class="k-message" @click="goMessage()">
      <el-badge :is-dot="info.views.is_read <= 0 ? false : true" class="item">
		  	<i class="el-icon-bell box"></i>
		  </el-badge>
	  </div>
      <div class="k-header-login">
        <el-dropdown @command="actionSelect" trigger="click">
          <span class="el-dropdown-link k-nav-header">
            <div class="user-avatar">
              <img src="../../assets/images/admin.png" />
            </div>
            <div class="user-info">
              <template v-if="info.views.admin_user == 1">
                <span class="user-name">超级管理员</span>
                <span class="user-role">管理员</span>
              </template>
              <template v-else>
                <span class="user-name">{{info.views.user.user_name || '-'}}</span>
                <span class="user-department">{{info.views.user.department_name || '-'}}{{info.views.user.position_name ? ' · ' + info.views.user.position_name : ''}}</span>
              </template>
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="changePass"><i class="el-icon-edit"></i>  修改密码</el-dropdown-item>
            <el-dropdown-item command="logout" divided><i class="el-icon-switch-button"></i>  退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>      
      </div>
      <div class="k-header-login" v-if="info.views.admin_user == 1">
        <el-dropdown @visible-change="loginOther" trigger="click">
          <span class="el-dropdown-link k-nav-header">
			<template v-if="info.views.is_supper == 'ADMIN'">
				切换账户
			</template>
			<template v-else>
				模拟身份：{{info.views.user.user_name}}
			</template>
            <i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-select size="mini" v-model="agent_id" filterable placeholder="请选择用户">
                <el-option
                  v-for="item in info.views.users"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-dropdown-item>
            <!-- <el-dropdown-item v-for="item in info.views.users" :key="item.value" command="changePass">{{ item.label }}</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>      
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="info.changePassFormVisiable"
      :append-to-body="true"
      size="30%"
    >
      <div class="demo-drawer__content">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-form
              :size="info.size"
              :model="info.changePassForm"
              ref="changePassForm"
              :rules="info.rules"
              label-width="110px"
            >
              <el-form-item label="当前密码" prop="password">
                <el-input
                  type="password"
                  v-model="info.changePassForm.password"
                  placeholder="请填写当前密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="新密码" prop="new_password">
                <el-input
                  type="password"
                  v-model="info.changePassForm.new_password"
                  placeholder="请填写新密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="再次输入" prop="re_new_password">
                <el-input
                  type="password"
                  v-model="info.changePassForm.re_new_password"
                  placeholder="请再次填写新密码"
                ></el-input>
              </el-form-item>

              <el-form-item label>
                <el-button type="primary" @click="changePass">提 交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['info'],
  data() {
    return {
      agent_id:'',
	  }
  },
  mounted(){
  },
  methods: {
    loginOther:function(value){
      if(!value && this.agent_id){
        this.$api.post('/admin/users/user/simulatedlogin', {id:this.agent_id,from_type: this.info.views.isSupper}).then(res => {
          if (res.code === 0) {
            localStorage.setItem('fy-token', res.msg)
            this.$message({
              showClose: true,
              message: '模拟登陆中',
              type: 'success'
            });
            setTimeout(() => {
              this.agent_id = ''
              window.location.href = '/'
              // window.location.replace("/")
            }, 1000);
          } else {
            this.$message.error(res.msg);
          }
        })
      }
    },
    clickMenu: function(key) {
      this.info.indexClic = key
      // 添加空值检查，避免 undefined 访问
      if (this.info.views.menus[key] && this.info.views.menus[key].children) {
        this.info.clickMenus = this.info.views.menus[key].children
        if (this.info.clickMenus.length > 0) {
          this.$router.push(this.info.clickMenus[0].menu_url).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
        }
      }
    },
    actionSelect: function(command) {
      if (command == 'changePass') {
        this.changePassOpen()
      } else if (command == 'logout') {
        this.logout()
      }
    },
    changePassOpen: function() {
      this.info.changePassFormVisiable = true
    },
    changePass: function() {
      this.$refs['changePassForm'].validate(
        function(valid) {
          if (valid) {
            this.$confirm('此操作将修改您的登录密码, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.$api.post('/admin/users/login/editpassword', this.info.changePassForm).then(res => {
                    if (res.code == 0) {
                      this.$message({
                        type: 'success',
                        duration: 3000,
                        message: '密码修改成功'
                      })
                      setTimeout(() => {
                        this.$router.replace('/login')
                      }, 3000)
                    } else {
                      this.$message({
                        type: 'error',
                        message: res.msg
                      })
                    }
                    this.info.changePassFormVisiable = false
                  })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消修改'
                })
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    logout: function() {
      this.$confirm('您将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.$api.post('/admin/users/login/logout').then(res => {
            if (res && res.code == 0) {
              //this.$router.replace('/login')
              // this.$router.go(0)
              // 清除本地存储中的 token
              localStorage.removeItem('fy-token');
              window.location.href = '/#/login'
            } else {
              this.$message({
                type: 'error',
                message: '退出登录失败'
              })
            }
          })
        }.bind(this)
      )
    },
	goMessage(){
		if(this.$route.fullPath != '/Message'){
			this.$router.push('Message')
		}
	},
	goHome(){
    if(this.$route.path != '/'){
      this.$router.push('/')
    }
	}
  }
}
</script>
<style lang="scss" scoped>
.k-header {
  height: 64px;
  background: #041b39;
  z-index: 999;
}
.k-header-con {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 1024px;
  height: 64px;
  font-size: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: #041b39;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.03);
}
.k-header-logo {
  display: inline-block;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  padding: 0 20px;
}
.k-header-logo span{
	font-size: 12px;
	color: #9ca5b1;
	margin-top: 6px;
	margin-left: 10px;
}
.k-header-nav {
  flex: 1;
  height: 100%;
  vertical-align: top;
}
.k-header-nav li {
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  float: left;
  height: 60px;
  line-height: 60px;
}
.k-header-nav li a {
  display: inline-block;
  padding: 22px 20px;
  font-size: 14px;
  line-height: 1.5;
  text-decoration: none !important;
  color: #9ca5b1;
}
.k-header-nav li a:hover {
  color: #fff;
}
.k-header-nav li.hov a {
  color: #fff;
}
.k-header-nav li.hov a::after {
  position: absolute;
  bottom: 11px;
  left: 50%;
  display: inline-block;
  width: 26px;
  height: 4px;
  content: '';
  background: #2f88ff;
  border-radius: 2px;
  transform: translateX(-50%);
}
.k-header-logo img {
  width: 104px;
}
.k-message{
	height: 64px;
	display:flex;
	align-items: center;
	padding: 0 24px;
	cursor: pointer;
	position: relative;
}
.k-message::after{
	content: "";
	display: block;
	width: 1px;
	height: 14px;
	background-color: #bfc6cd;
	position: absolute;
	top: 25px;
	right: 0;
}
.k-message .box{
	font-size: 20px;
	color: #bfc6cd;
}
</style>
